import clsx from 'clsx';
import React from 'react';

import ForYouSectionHeader from './SectionHeader';
import type { ForYouSectionProps } from './interfaces';

const ForYouSection = ({
  children,
  className,
  disableBorder = false,
  headerLink,
  headerLinkText,
  highlight,
  id,
  subtitle,
  title,
  titleSize,
}: ForYouSectionProps) => {
  return (
    <article
      className={clsx(
        'mt-24 scroll-mt-24 border-0 sm:mt-80 nav:scroll-mt-80',
        !disableBorder && 'border-t border-solid border-grayscale-gray pt-24 sm:pt-80',
        className
      )}
      id={id}
    >
      <ForYouSectionHeader
        headerLink={headerLink}
        headerLinkText={headerLinkText}
        highlight={highlight}
        subtitle={subtitle}
        title={title}
        titleSize={titleSize}
      />
      {children}
    </article>
  );
};

export default ForYouSection;
